export default "__VITE_ASSET__Cp2gpbbz__";